// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Vi0v","name":"Header_name__kAX_m","birthday":"Header_birthday__2YJHU","skeleton":"Header_skeleton__14Nql"};